<template>
  <div id="bg-image" :style="{'background-image':'url(' + background.image + ')'}"></div>
</template>

<script>
import { defineComponent, reactive, computed, onMounted } from 'vue'
import { judgePageType } from '@/util/common'
import store from '@/store'
import * as common from '@/util/common'

export default defineComponent({
  setup (props, context) {

    onMounted(() => {
      // ページタイプ(pc / sp / public)の判定
      group1.page_type = common.judgePageType()
    })

    const group1 = reactive({
      page_type: ''
    })

    const background = reactive({
      image: computed(() => {
        let image = null
        if (group1.page_type === 'pc' || group1.page_type === 'sp') {
          // PCページ、SPページの場合は設定している背景画像を表示
          const template = store.state.profile.template
          image = common.getTemplateImage(template)
        } else {
          // publicの場合はデフォルトの背景画像を表示
          image = common.getPublicTemplateImage()
        }
        return image
      })
    })

    return {
      group1,
      background
    }
  }
})
</script>

<style lang="scss" scoped>
</style>
